import { render, staticRenderFns } from "./OrderListFiltersDrawer.vue?vue&type=template&id=2db0d2b2"
import script from "./OrderListFiltersDrawer.vue?vue&type=script&lang=js"
export * from "./OrderListFiltersDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports